import React from "react";

export default function ScoreBadge({ score, band, size = "sm" }) {
  const b = band || (score >= 80 ? "high" : score >= 60 ? "medium" : "nurture");
  const map = {
    high: "bg-[hsl(var(--success)/0.12)] text-[hsl(var(--success))] border-[hsl(var(--success)/0.3)]",
    medium: "bg-[hsl(var(--warning)/0.12)] text-[hsl(var(--warning))] border-[hsl(var(--warning)/0.3)]",
    nurture: "bg-muted text-muted-foreground border-border",
  };
  const label = b === "high" ? "High" : b === "medium" ? "Medium" : "Nurture";
  return (
    <span
      data-testid={`score-badge-${b}`}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 border text-xs font-mono ${map[b]}`}
      style={{ borderRadius: 2 }}
    >
      <span className="font-semibold">{score ?? 0}</span>
      <span className="text-[10px] uppercase tracking-[0.15em]">{label}</span>
    </span>
  );
}
